import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { msalInstance } from '../..';
import { silentRequest } from '../../authConfig';
import { setTimedOutModal } from '../../store/reducers/timedOutReducer';
import { EnhancedStore } from '@reduxjs/toolkit';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const REACT_OCP_APIM_SUBSCRIPTION_KEY =
	process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY;

let initialStore: EnhancedStore; // Store reference

export const injectStore = (_store: EnhancedStore) => {
	initialStore = _store;
};

export const isTokenExpired = (token: string) => {
	if (!token) {
		return true;
	}

	const decodedToken = jwtDecode(token);
	const currentTime = Date.now() / 1000;

	if (!decodedToken || !decodedToken.exp) {
		return true;
	}

	return decodedToken.exp < currentTime;
};

export const getToken = async () => {
	try {
		const account = msalInstance.getActiveAccount();
		if (account) {
			const response = await msalInstance.acquireTokenSilent({
				...silentRequest,
				account: account,
			});
			if (isTokenExpired(response.idToken)) {
				const response = await msalInstance.acquireTokenSilent({
					...silentRequest,
					account: account,
					forceRefresh: true,
				});
				return response.idToken;
			}
			return response.idToken;
		}
	} catch (error) {
		msalInstance.loginRedirect({
			scopes: [(process.env.REACT_APP_SCOPES as string) || ''],
		});
	}
};

const axiosInstance = axios.create({
	baseURL: BASE_URL,
	headers: {
		'Ocp-Apim-Subscription-Key': REACT_OCP_APIM_SUBSCRIPTION_KEY,
	},
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
axiosInstance.interceptors.request.use(async (request: any) => {
	// Acquires the access token from session storage which is then attached to a request
	try {
		const accessToken = sessionStorage.getItem(
			(process.env.REACT_APP_SCOPES as string) || '',
		);
		if (accessToken) {
			if (isTokenExpired(accessToken)) {
				initialStore.dispatch(
					setTimedOutModal({
						isModalOpen: true,
					}),
				);
			} else {
				request.headers.Authorization = `Bearer ${accessToken}`;
			}
		} else {
			msalInstance.loginRedirect({
				scopes: [(process.env.REACT_APP_SCOPES as string) || ''],
			});
		}
	} catch (error) {
		// //Should not be used according to MS documentation
		// if (error instanceof InteractionRequiredAuthError) {
		//    instance.acquireTokenRedirect(accessTokenRequest)
		// }
		msalInstance.loginRedirect({
			scopes: [(process.env.REACT_APP_SCOPES as string) || ''],
		});
		console.log(error);
	}

	return request;
});

export default axiosInstance;
